import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { formatDate } from '../../helpers/formatted-dates';
import DatePicker from "react-datepicker";
import InputAuto from '../../helpers/input-auto';
import TextAuto from '../../helpers/text-auto';
import Modal from 'react-bootstrap/Modal';
import { catchError } from '../../helpers/catch-error'
import { useNavigate } from "react-router-dom";



const Notes = ({ work_order, onWorkOrderChange }) => {

    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [addMode, setAddMode] = useState(false);
    const [isNoteModalOpen, setIsNoteModalOpen] = useState(null);


    const [notes, setNotes] = useState(null);
    const [noteStatuses, setNoteStatuses] = useState(null);


    const [noteAdd, setNoteAdd] = useState(null);
    const [noteEdit, setNoteEdit] = useState(null);

    const [inputError, setInputError] = useState(false);



    useEffect(() => {

        if (work_order?.work_order_id > 0) {
            getNoteStatuses();
            getNotes();
        }

    }, [work_order?.work_order_id, work_order?.status]);



    const getNoteStatuses = async (e) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-note-statuses/" + work_order.work_order_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setNoteStatuses(response?.data?.note_statuses);


            } else {

                Swal.fire({ icon: "error", title: "Note Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }




    const getNotes = async () => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-notes-by-work-order-id/" + work_order?.work_order_id,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setNotes(response?.data?.notes)
                    if (!response?.data?.notes) {
                        addNote();
                    }



                } else {
                    Swal.fire({ icon: "error", title: "note Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {

                catchError(error, navigate)


            });


    }


    const addNote = async () => {

        let d = new Date();
        let day = d.getDay();
        let incrday = 0;

        if (day <= 2) {
            incrday = 3;
        } else if (day <= 5) {
            incrday = 5;
        } else if (day == 6) {
            incrday = 4;
        }

        d.setDate(d.getDate() + incrday);

        d = formatDate(d);
        // alert(d);

        setNoteAdd({
            note_status: "",
            follow_up_date: d,
            wo_status: 3,
            case_manager_access: 0,
            note_description: "",
            note_internal_description: ""

        });
        setAddMode(true);

    }


    const saveNote = async (e) => {



        setIsBtn(true);
        let error_flag = false;



        if (!noteAdd?.note_status || !noteAdd?.follow_up_date ||
            !noteAdd?.wo_status || !/^\d{2}\/\d{2}\/\d{4}$/.test(noteAdd?.follow_up_date)) {

            error_flag = true;
        }

        // Fee Approval Validation (Allows empty/null, requires exact 2 decimal places if provided)
        const isFeeApproved = noteAdd?.fee_approval == 1 || noteAdd?.fee_approval === true;
        const hasFeeValue = noteAdd?.fee_approval_amount !== undefined && noteAdd?.fee_approval_amount !== null && noteAdd?.fee_approval_amount.toString().trim() !== "";

        const isValidFee = !isFeeApproved || !hasFeeValue || /^\d+\.\d{2}$/.test(noteAdd?.fee_approval_amount.toString().trim());

        if (!isValidFee) {
            error_flag = true;
        }

        if (error_flag) {

            setInputError(true);
            setIsBtn(false);

        } else {


            // 🔴 Check BEFORE validation or API call
            if (noteAdd?.case_manager_access == 1) {
                const result = await Swal.fire({
                    icon: "warning",
                    title: "Visible to Client",
                    text: "This note will be visible to Client / Case Manager. Do you want to continue?",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Save",
                    cancelButtonText: "Cancel"
                });

                if (!result.isConfirmed) {
                    return; // ⛔ stop execution
                }
            }

            var note_info = {
                work_order_id: work_order?.work_order_id,
                note_status: noteAdd?.note_status,
                follow_up_date: noteAdd?.follow_up_date,
                wo_status: noteAdd?.wo_status,
                case_manager_access: noteAdd?.case_manager_access,
                note_description: noteAdd?.note_description,
                note_internal_description: noteAdd?.note_internal_description,
                pending_payments: noteAdd?.pending_payments,
                paid_payments: noteAdd?.paid_payments,
                problem_case: noteAdd?.problem_case,
                problem_reason: noteAdd?.problem_reason,
                correspondence_attachment: noteAdd?.correspondence_attachment,
                fee_approval: noteAdd?.fee_approval,
                fee_approval_amount: noteAdd?.fee_approval_amount


            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-note", note_info, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    getNotes();
                    setAddMode(false)
                    if (response?.data?.follow_up_date != null) {
                        onWorkOrderChange({ follow_up_date: response?.data?.follow_up_date });
                    }


                } else {

                    Swal.fire({ icon: "error", title: "Note Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }


    }



    const editNote = async (note_id) => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-note-by-id/" + note_id,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setNoteEdit(response?.data?.note);
                    setIsNoteModalOpen(true);

                } else {
                    Swal.fire({ icon: "error", title: "note Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {

                catchError(error, navigate)

            });


    }


    const updateNote = async (e) => {


        setIsBtn(true);
        let error_flag = false;


        if (!noteEdit?.note_status || !noteEdit?.follow_up_date ||
            !noteEdit?.wo_status || !/^\d{2}\/\d{2}\/\d{4}$/.test(noteEdit?.follow_up_date)) {

            error_flag = true;
        }
        // Fee Approval Validation (Allows empty/null, requires exact 2 decimal places if provided)
        const isFeeApproved = noteEdit?.fee_approval == 1 || noteEdit?.fee_approval === true;
        const hasFeeValue = noteEdit?.fee_approval_amount !== undefined && noteEdit?.fee_approval_amount !== null && noteEdit?.fee_approval_amount.toString().trim() !== "";

        const isValidFee = !isFeeApproved || !hasFeeValue || /^\d+\.\d{2}$/.test(noteEdit?.fee_approval_amount.toString().trim());

        if (!isValidFee) {
            error_flag = true;
        }

        if (error_flag) {

            setInputError(true);
            setIsBtn(false);

        } else {

            // 🔴 Check BEFORE validation or API call
            if (noteEdit?.case_manager_access == 1) {
                const result = await Swal.fire({
                    icon: "warning",
                    title: "Visible to Client",
                    text: "This note will be visible to Client / Case Manager. Do you want to continue?",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Save",
                    cancelButtonText: "Cancel"
                });

                if (!result.isConfirmed) {
                    return; // ⛔ stop execution
                }
            }

            var note_info = {
                note_id: noteEdit?.note_id,
                work_order_id: work_order?.work_order_id,
                note_status: noteEdit?.note_status,
                follow_up_date: noteEdit?.follow_up_date,
                wo_status: noteEdit?.wo_status,
                case_manager_access: noteEdit?.case_manager_access,
                note_description: noteEdit?.note_description,
                note_internal_description: noteEdit?.note_internal_description,
                pending_payments: noteEdit?.pending_payments,
                paid_payments: noteEdit?.paid_payments,
                problem_case: noteEdit?.problem_case,
                problem_reason: noteEdit?.problem_reason,
                correspondence_attachment: noteEdit?.correspondence_attachment,
                remove_attachment: noteEdit?.remove_attachment,
                fee_approval: noteEdit?.fee_approval,
                fee_approval_amount: noteEdit?.fee_approval_amount

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-note", note_info, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    getNotes(response?.data?.note);
                    setIsNoteModalOpen(false)

                } else {

                    Swal.fire({ icon: "error", title: "Note Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }


    }



    const isGreaterThanYesterday = async (e) => {

        let yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);

        const note_date = new Date(e);
        if (note_date >= yesterday)
            return true;
        else
            return false;



    }


    const toggleNoteAccess = async (note_id, access) => {

        var note_info = {
            note_id: note_id,
            case_manager_access: access,
        }
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/toggle-note-access", note_info, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {

                getNotes(response?.data?.note);
                setIsNoteModalOpen(false)

            } else {

                Swal.fire({ icon: "error", title: "Note Info", text: response?.data?.message });

            }
            setIsBtn(false)

        }).catch(function (error) {

            setIsBtn(false);
            catchError(error, navigate)

        });

    }


    const closeWorkOrder = async () => {

        Swal.fire({
            text: "Closing this work order will lock the record and no more activity will be allowed.",
            input: "text",
            icon: "warning",
            inputAttributes: {
                autocapitalize: "off"
            },
            inputLabel: "Closing Notes",
            showCancelButton: true,
            confirmButtonText: "Close Work Order",
            showLoaderOnConfirm: true,

            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {

            if (result.isConfirmed) {

                axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/close-work-order",
                    { closing_notes: result.value, work_order_id: work_order.work_order_id },
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        withCredentials: true
                    }).then(async function (response) {

                        if (response?.data?.status) {

                            onWorkOrderChange({ "status": 7 });
                            Swal.fire({ icon: "success", title: "Work Order Closed", text: "Work Order Closed Successfully" });


                        } else {

                            Swal.fire({ icon: "error", title: "Work Order", text: response?.data?.message });

                        }
                        setIsBtn(false)

                    }).catch(function (error) {

                        setIsBtn(false);
                        catchError(error, navigate)

                    });
            }
            else {
                setIsBtn(false);

            }
        });

    }



    const rejectWorkOrder = async () => {

        setIsBtn(true);


        Swal.fire({
            title: "Are you sure, you want to reject this?",
            text: "You won't be able to revert this action!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, reject it!"
        }).then((result) => {
            if (result.isConfirmed) {



                axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/reject-work-order/", { work_order_id: work_order?.work_order_id }, {
                    withCredentials: true
                })
                    .then(function (response) {

                        setIsBtn(false);
                        if (response?.data?.status) {

                            onWorkOrderChange({ "status": 9 });




                        } else {

                            Swal.fire({ icon: "error", title: "Unable to reject", text: response?.data?.message });

                        }

                    })
                    .catch(function (error) {

                        catchError(error, navigate)

                    });


            }
            else {
                setIsBtn(false);

            }
        });

    }



    const cancelWorkOrder = async () => {

        setIsBtn(true);

        setIsBtn(true);


        Swal.fire({
            title: "Are you sure, you want to cancel this?",
            text: "You won't be able to revert this action!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, cancel it!"
        }).then((result) => {
            if (result.isConfirmed) {


                axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/cancel-work-order/", { work_order_id: work_order?.work_order_id }, {
                    withCredentials: true
                })
                    .then(function (response) {
                        setIsBtn(false);
                        if (response?.data?.status) {

                            onWorkOrderChange({ "status": 8 });


                        } else {

                            Swal.fire({ icon: "error", title: "Unable to cancel", text: response?.data?.message });

                        }

                    })
                    .catch(function (error) {

                        catchError(error, navigate)

                    });
            }
            else {
                setIsBtn(false);

            }

        });
    }

    const convertETToLocal = (dateStr, timeStr) => {
        // 0. Sanitize inputs to safely handle null, undefined, or empty values
        const date = dateStr ? String(dateStr).trim() : '';
        const time = timeStr ? String(timeStr).trim() : '';

        if (!date && !time) return '';

        try {
            // 1. Direct MM/DD/YYYY parsing
            const delimiter = date.includes('/') ? '/' : '-';
            const parts = date.split(delimiter);

            if (parts.length !== 3) return date;

            const month = parts[0].padStart(2, '0');
            const day = parts[1].padStart(2, '0');
            const year = parts[2];

            // 2. Parse 24-hour / 12-hour time components
            let hours = 0, minutes = 0, seconds = 0;

            if (/am|pm/i.test(time)) {
                const isPM = /pm/i.test(time);
                const cleanTime = time.replace(/(am|pm)/i, '').trim();
                const timeParts = cleanTime.split(':');
                hours = parseInt(timeParts[0], 10);
                minutes = parseInt(timeParts[1] || '0', 10);
                seconds = parseInt(timeParts[2] || '0', 10);

                if (isPM && hours < 12) hours += 12;
                if (!isPM && hours === 12) hours = 0;
            } else {
                const timeParts = time.split(':');
                hours = parseInt(timeParts[0], 10);
                minutes = parseInt(timeParts[1] || '0', 10);
                seconds = parseInt(timeParts[2] || '0', 10);
            }

            const formattedHours = String(hours).padStart(2, '0');
            const formattedMinutes = String(minutes).padStart(2, '0');
            const formattedSeconds = String(seconds).padStart(2, '0');

            // 3. Construct ISO base (YYYY-MM-DD) for Eastern Time
            const isoBase = `${year}-${month}-${day}T${formattedHours}:${formattedMinutes}:${formattedSeconds}`;

            // Determine if date falls under EDT (-04:00) or EST (-05:00)
            const etOffset = new Date(isoBase)
                .toLocaleString('en-US', { timeZone: 'America/New_York', timeZoneName: 'short' });

            const isEDT = etOffset.includes('EDT');
            const offsetString = isEDT ? '-04:00' : '-05:00';

            // 4. Instantiate Date object with Eastern Time offset
            const localDate = new Date(`${isoBase}${offsetString}`);

            if (isNaN(localDate.getTime())) return `${date} ${time}`.trim();

            // 5. Format local output date (MM/DD/YYYY)
            const localMonth = String(localDate.getMonth() + 1).padStart(2, '0');
            const localDay = String(localDate.getDate()).padStart(2, '0');
            const localYear = localDate.getFullYear();
            const formattedLocalDate = `${localMonth}/${localDay}/${localYear}`;

            // 6. Format local output 24-hour time (HH:mm:ss)
            const formattedLocalTime = localDate.toLocaleTimeString('en-GB', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            });

            return `${formattedLocalTime}`;

        } catch (e) {
            console.error("ET Conversion error:", e);
            return `${date} ${time}`.trim();
        }
    };
    return (

        <>
            {(work_order?.authorization_status == 1 && work_order?.status >= 1) &&

                <div className="card card-form" >
                    <div className="card-body p-0" >

                        <div className=" card-heading row m-0" >

                            <div className="col py-1">

                                <div className="  py-2 fw-bold text-dark">ACTIVITY HISTORY</div>

                            </div>
                            <div className="col py-1 text-end">

                                {(addMode) ?
                                    <>
                                        <button onClick={() => saveNote()} className="btn btn-sm  btn-success me-1 mt-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SAVE STATUS"}</button>
                                        <button onClick={() => { setAddMode(false); setNoteAdd(null); }} className="btn btn-sm  btn-warning me-1 mt-1" type="button" >CANCEL SAVE</button>
                                    </>
                                    :
                                    <>
                                        {((work_order?.authorization_status == 1 && work_order?.status < 4 && work_order?.status >= 1) || work_order?.flag == "1") &&
                                            <button onClick={() => addNote()} className="btn btn-sm    btn-success me-1 mt-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPDATE"}</button>
                                        }
                                        {work_order?.status < 7 &&
                                            <button onClick={() => closeWorkOrder()} className="btn btn-sm    btn-warning me-1 mt-1" type="button">CLOSE</button>

                                        }
                                        {(work_order && work_order?.status < 4) &&
                                            <>
                                                {/*--   <button disabled={isBtn} onClick={() => { rejectWorkOrder(); }} className="btn btn-sm btn-danger mx-1 " type="button"> {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : 'Reject'}</button> --*/}
                                                <button disabled={isBtn} onClick={() => { cancelWorkOrder(); }} className="btn btn-sm btn-primary " type="button"> {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : 'Cancel'}</button>
                                            </>
                                        }
                                    </>
                                }

                            </div>


                        </div>

                        {(addMode) &&
                            <>
                                <form method="post" action="" encType="multipart/form-data" name="updates" id="updates">
                                    <div className="row px-3 py-2 gx-2 ">
                                        <div className="col-10">
                                            <label className="control-label">STATUS*</label>
                                            <TextAuto
                                                name="note_status"
                                                className="form-control"
                                                minStart="3"
                                                value={noteAdd?.note_status}
                                                pholder="Type status..."
                                                data={noteStatuses}
                                                field="note_status"
                                                onChange={(e) => setNoteAdd({ ...noteAdd, note_status: e })}
                                                onSelected={(e) => {
                                                    setNoteAdd({ ...noteAdd, note_status: e.note_status })
                                                }}
                                            />
                                            {inputError &&
                                                (!noteAdd.note_status) && (
                                                    <span className="text-danger">Enter status</span>
                                                )}

                                        </div>


                                        <div className="col-2">
                                            <label className="control-label">FOLLOW UP DATE:*</label>

                                            <DatePicker name="follow_up_date" id="follow_up_date" type="text"
                                                className="form-control custom-date-height" placeholder="MM/DD/YYYY" showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                selected={noteAdd?.follow_up_date}
                                                onChange={(e) => {
                                                    const formatted_date = formatDate(e)
                                                    setNoteAdd({ ...noteAdd, follow_up_date: formatted_date })

                                                }
                                                }
                                            />
                                            {inputError &&
                                                (!noteAdd?.follow_up_date || !/^\d{2}\/\d{2}\/\d{4}$/.test(noteAdd?.follow_up_date)) && (
                                                    <span className="text-danger">Enter valid follow up date</span>
                                                )}



                                        </div>

                                    </div>


                                    <div className="row px-3 py-2 gx-2 ">



                                        <div className="col-7">
                                            <label htmlFor="case_manager_access">ACTION REQUIRED BY: </label>


                                            <div className="form-check-inline">

                                                <input className="me-1 form-check-input" onClick={(e) => setNoteAdd({ ...noteAdd, wo_status: 1 })} type="radio" name="wo_status" value="1" checked={(noteAdd?.wo_status == 1 || noteAdd?.wo_status == .5) ? true : false} />
                                                <label className="me-0 form-check-label fw-normal"  >ADMINISTRATOR</label>
                                            </div>
                                            <div className="form-check-inline">
                                                <input className="me-1 form-check-input " onClick={(e) => setNoteAdd({ ...noteAdd, wo_status: 2 })} type="radio" name="wo_status" value="2" checked={noteAdd?.wo_status == 2 ? true : false} />
                                                <label className="me-0 form-check-label fw-normal"  >CLIENT/CASE MANAGER</label>
                                            </div>
                                            <div className="form-check-inline">
                                                <input className="me-1 form-check-input " onClick={(e) => setNoteAdd({ ...noteAdd, wo_status: 3 })} type="radio" name="wo_status" value="3" checked={noteAdd?.wo_status == 3 ? true : false} />
                                                <label className="me-0 form-check-label fw-normal"  >BOTH</label>
                                            </div>

                                            {inputError &&
                                                (!noteAdd?.wo_status) && (
                                                    <span className="text-danger">Enter action required by</span>
                                                )}



                                        </div>




                                        <div className="col-5">
                                            <label htmlFor="case_manager_access" className="me-1">Notes visible by Client/Case Managers: </label>

                                            <div className="form-check-inline">

                                                <input className="me-1 form-check-input" onClick={(e) => setNoteAdd({ ...noteAdd, case_manager_access: 1 })} type="radio" name="case_manager_access" value="1" checked={noteAdd?.case_manager_access == 1 ? true : false} />
                                                <label className="me-0 form-check-label fw-normal"  >YES</label>
                                            </div>
                                            <div className="form-check-inline">
                                                <input className="me-1 form-check-input " onClick={(e) => setNoteAdd({ ...noteAdd, case_manager_access: 0 })} type="radio" name="case_manager_access" value="0" checked={noteAdd?.case_manager_access == 0 ? true : false} />
                                                <label className="me-0 form-check-label fw-normal"  >NO</label>
                                            </div>




                                        </div>

                                    </div>

                                    <div className="row px-3 py-2 gx-2 align-items-center">

                                        <div className="col-auto">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={!!noteAdd?.pending_payments}
                                                    onChange={(e) =>
                                                        setNoteAdd({
                                                            ...noteAdd,
                                                            pending_payments: e.target.checked ? 1 : 0,
                                                        })
                                                    }
                                                />
                                                <label className="form-check-label">Pending Payment</label>
                                            </div>
                                        </div>

                                        <div className="col-auto">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={!!noteAdd?.paid_payments}
                                                    onChange={(e) =>
                                                        setNoteAdd({
                                                            ...noteAdd,
                                                            paid_payments: e.target.checked ? 1 : 0,
                                                        })
                                                    }
                                                />
                                                <label className="form-check-label">Paid</label>
                                            </div>
                                        </div>

                                        <div className="col-auto">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={noteAdd?.problem_case == 1 || noteAdd?.problem_case === true}
                                                    onChange={(e) =>
                                                        setNoteAdd({
                                                            ...noteAdd,
                                                            problem_case: e.target.checked ? 1 : 0,
                                                            problem_reason: e.target.checked
                                                                ? noteAdd?.problem_reason
                                                                : ""
                                                        })
                                                    }
                                                />
                                                <label className="form-check-label">Problem Case</label>
                                            </div>
                                        </div>

                                        {/* Conditional Problem Reason Input */}
                                        {(noteAdd?.problem_case == 1 || noteAdd?.problem_case === true) && (
                                            <>
                                                <div className="col-auto">
                                                    <label className="mb-0">Reason:</label>
                                                </div>

                                                <div className="col-auto" style={{ maxWidth: "300px" }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter reason"

                                                        value={noteAdd?.problem_reason || ""}
                                                        onChange={(e) =>
                                                            setNoteAdd({
                                                                ...noteAdd,
                                                                problem_reason: e.target.value
                                                            })
                                                        }
                                                    />
                                                </div>
                                            </>
                                        )}

                                        {/* Fee Approval Checkbox */}
                                        <div className="col-auto">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={noteAdd?.fee_approval == 1 || noteAdd?.fee_approval === true}
                                                    onChange={(e) =>
                                                        setNoteAdd({
                                                            ...noteAdd,
                                                            fee_approval: e.target.checked ? 1 : 0,
                                                            fee_approval_amount: e.target.checked
                                                                ? noteAdd?.fee_approval_amount
                                                                : ""
                                                        })
                                                    }
                                                />
                                                <label className="form-check-label">Fee Approval</label>
                                            </div>
                                        </div>

                                        {/* Conditional Fee Text Input (Max 100px) */}
                                        {(noteAdd?.fee_approval == 1 || noteAdd?.fee_approval === true) && (
                                            <>
                                                <div className="col-auto">
                                                    <label className="mb-0">Fee:</label>
                                                </div>

                                                <div className="col-auto" style={{ maxWidth: "120px" }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Fee"
                                                        value={noteAdd?.fee_approval_amount || ""}
                                                        onChange={(e) =>
                                                            setNoteAdd({
                                                                ...noteAdd,
                                                                fee_approval_amount: e.target.value
                                                            })
                                                        }
                                                    />
                                                    {inputError &&
                                                        noteAdd?.fee_approval_amount &&
                                                        !/^\d+\.\d{2}$/.test(noteAdd?.fee_approval_amount.toString().trim()) && (
                                                            <span className="text-danger">Enter a valid fee amount (e.g. 100.00)</span>
                                                        )
                                                    }
                                                </div>
                                            </>
                                        )}

                                    </div>

                                    <div className="row px-3 py-2 gx-2 ">
                                        <div className="col-4">
                                            <label htmlFor="note_description">NOTES</label>
                                            <textarea rows="4" name="note_description" id="note_description"
                                                className="form-control"
                                                onChange={(e) =>
                                                    setNoteAdd({ ...noteAdd, note_description: e.target.value })
                                                }

                                            >
                                                {noteAdd?.note_description}
                                            </textarea>


                                        </div>
                                        <div className="col-4">
                                            <label htmlFor="note_internal_description">INTERNAL NOTES </label>
                                            <textarea rows="4" name="note_internal_description" id="note_internal_description"
                                                className="form-control"
                                                onChange={(e) =>
                                                    setNoteAdd({ ...noteAdd, note_internal_description: e.target.value })
                                                }

                                            >
                                                {noteAdd?.note_internal_description}
                                            </textarea>


                                        </div>

                                        <div className="col-4">
                                            <label htmlFor="correspondence_attachment">CORRESPONDENCE ATTACHMENT</label>
                                            <div className="input-group w-auto mt-1">
                                                <input
                                                    name="correspondence_attachment"
                                                    id="correspondence_attachment"
                                                    type="file"
                                                    className="form-control"
                                                    onChange={(e) =>
                                                        setNoteAdd({ ...noteAdd, correspondence_attachment: e.target.files[0] })
                                                    }
                                                />
                                            </div>
                                        </div>

                                    </div>



                                </form>

                            </>
                        }
                        <>
                            {(notes) ?
                                <>

                                    <div className="row px-3 py-2 gx-2 ">
                                        <div className="col-md-2 col-sm-2">
                                            <label className="control-label">Date </label>
                                        </div>
                                        <div className="col-md-7 col-sm-7">
                                            <label className="control-label">STATUS </label>
                                        </div>
                                        <div className="col-md-2 col-sm-2">
                                            <label className="control-label">UPDATED BY</label>
                                        </div>
                                        <div className="col-md-1 col-sm-1">
                                            <label className="control-label">Time</label>
                                        </div>



                                    </div>

                                    {notes.map((p, index) => {
                                        return (
                                            <div className="row px-3 py-2 gx-2 ">
                                                <div className="col-md-2 col-sm-2">
                                                    <label className="field-info">
                                                        {p.note_date_formatted + ' '}

                                                    </label>
                                                </div>
                                                <div className="col-md-7 col-sm-7">
                                                    <label className="field-info tt-none" >

                                                        {p.note_status &&
                                                            <>
                                                                <b>Status:</b> {p.note_status} <br />
                                                            </>
                                                        }

                                                        {p.note_description &&
                                                            <>
                                                                <b>Note:</b> {p.note_description} <br />
                                                            </>
                                                        }

                                                        {p.note_internal_description &&
                                                            <>
                                                                <b>Internal Note:</b> {p.note_internal_description} <br />
                                                            </>
                                                        }

                                                        {p.correspondence_attachment && (
                                                            <>
                                                                <b>Correspondence Attachment:</b>{' '}
                                                                <a
                                                                    className="btn btn-sm btn-link text-primary p-0"
                                                                    href={`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/download-correspondence-attachment/${p.note_id}`}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    Download
                                                                </a>
                                                                <br />
                                                            </>
                                                        )}

                                                        {p.case_manager_access === 0 ?
                                                            <>
                                                                <b><font className="red10">Note Not Visible to Client/Case Manager</font></b> |
                                                                <a className="btn btn-sm btn-link text-danger ps-0" href="javascript:void(0);" onClick={() => toggleNoteAccess(p.note_id, 1)}>[Show note to Client/Case Manager]</a>
                                                            </>
                                                            :
                                                            <a className="btn btn-sm btn-link text-danger ps-0" href="javascript:void(0);" onClick={() => toggleNoteAccess(p.note_id, 0)} >[Hide note from Client/Case Manager]</a>
                                                        }


                                                        {isGreaterThanYesterday(p.note_date) &&

                                                            <a href="javascript:void(0);" onClick={() => editNote(p.note_id)} name="update_status" id="update_status" className="update_status" rel="update_work_order.php?note_id={p.note_id}&order={p.work_order_id}">Update Work Order Status</a>


                                                        }



                                                        {/* Problem Case Display */}
                                                        {(p.problem_case == 1 || p.problem_case === true) && (
                                                            <>
                                                                <br />
                                                                <b className="text-danger">Problem Case:</b> Yes
                                                                {p.problem_reason?.trim() ? `, Reason: ${p.problem_reason}` : ""}
                                                            </>
                                                        )}

                                                        {/* Fee Approval Display */}
                                                        {(p.fee_approval == 1 || p.fee_approval === true) && (
                                                            <>
                                                                <br />
                                                                <b className="text-success">Fee Approval:</b> Yes
                                                                {p.fee_approval_amount?.toString().trim() ?  `, Fee: $${Number(p.fee_approval_amount).toFixed(2)}` : ""}
                                                            </>
                                                        )}


                                                    </label>
                                                </div>
                                                <div className="col-md-2 col-sm-2">
                                                    <label className="field-info" >{p?.note_author}</label>
                                                </div>
                                                <div className="col-md-1 col-sm-1">
                                                    <label className="field-info" >
                                                        {p?.note_time ? convertETToLocal(p.note_date_formatted, p.note_time) : ''}
                                                    </label>
                                                </div>
                                            </div>
                                        )
                                    })}


                                </>
                                :
                                <div className="row " >

                                    <div className="col-xl-12 col-lg-12 py-4 " >

                                        <h5 className="px-3 text-danger">No status update has been added yet.</h5>

                                    </div>

                                </div>
                            }
                        </>

                    </div>

                </div >

            }



            <Modal animation={false}
                show={isNoteModalOpen}
                onHide={() => { setIsNoteModalOpen(false); }}
                keyboard={false}
                backdrop="static"
                id="note-modal"
                size="lg"
            >
                <Modal.Header><h3 className="m-0 p-0">UPDATE NOTE</h3></Modal.Header>
                <Modal.Body>

                    <div className="card card-form border-0" >
                        <div className="card-body p-0" >

                            <div className="modal-inner-content ">



                                <form method="post" action="" encType="multipart/form-data" name="frm_note_update" id="frm_note_update">
                                    <div className="row px-3 py-2 gx-2 ">
                                        <div className="col-9">
                                            <label className="control-label">STATUS*</label>
                                            <InputAuto name="note_status" className="form-control" minStart="3"
                                                value={noteEdit?.note_status}
                                                pholder=""
                                                data={noteStatuses}
                                                field="note_status"
                                                onChange={(e) =>
                                                    setNoteEdit({ ...noteEdit, note_status: e })
                                                }
                                                onSelected={(e) => {
                                                    setNoteEdit({ ...noteEdit, note_status: e.note_status })

                                                }
                                                }

                                            />
                                            {inputError &&
                                                (!noteEdit?.note_status) && (
                                                    <span className="text-danger">Enter status</span>
                                                )}

                                        </div>
                                        <div className="col-3 ">
                                            <label className="control-label">FOLLOW UP DATE*</label>

                                            <DatePicker name="follow_up_date" id="follow_up_date" type="text"
                                                className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                selected={noteEdit?.follow_up_date}
                                                onChange={(e) => {
                                                    const formatted_date = formatDate(e)
                                                    setNoteEdit({ ...noteEdit, follow_up_date: formatted_date })

                                                }
                                                }
                                            />
                                            {inputError &&
                                                (!noteEdit?.follow_up_date || !/^\d{2}\/\d{2}\/\d{4}$/.test(noteEdit?.follow_up_date)) && (
                                                    <span className="text-danger">Enter valid follow up date</span>
                                                )}



                                        </div>

                                    </div>


                                    <div className="row px-3 py-2 gx-2 ">



                                        <div className="col-7">
                                            <label htmlFor="case_manager_access">ACTION REQUIRED BY: </label>


                                            <div className="form-check">

                                                <input className="me-1 form-check-input" onClick={(e) => setNoteEdit({ ...noteEdit, wo_status: 1 })} type="radio" name="wo_status" value="1" checked={(noteEdit?.wo_status == 1 || noteEdit?.wo_status == .5) ? true : false} />
                                                <label className="me-0 form-check-label fw-normal"  >ADMINISTRATOR</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="me-1 form-check-input " onClick={(e) => setNoteEdit({ ...noteEdit, wo_status: 2 })} type="radio" name="wo_status" value="2" checked={noteEdit?.wo_status == 2 ? true : false} />
                                                <label className="me-0 form-check-label fw-normal"  >CLIENT/CASE MANAGER</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="me-1 form-check-input " onClick={(e) => setNoteEdit({ ...noteEdit, wo_status: 3 })} type="radio" name="wo_status" value="3" checked={noteEdit?.wo_status == 3 ? true : false} />
                                                <label className="me-0 form-check-label fw-normal"  >BOTH</label>
                                            </div>
                                            {inputError &&
                                                (!noteEdit?.wo_status) && (
                                                    <span className="text-danger">Enter action required by</span>
                                                )}


                                        </div>




                                        <div className="col-5">
                                            <label htmlFor="case_manager_access" className="me-1">Notes visible by Client/Case Managers: </label>

                                            <div className="form-check">

                                                <input className="me-1 form-check-input" onClick={(e) => setNoteEdit({ ...noteEdit, case_manager_access: 1 })} type="radio" name="case_manager_access" value="1" checked={noteEdit?.case_manager_access == 1 ? true : false} />
                                                <label className="me-0 form-check-label fw-normal"  >YES</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="me-1 form-check-input " onClick={(e) => setNoteEdit({ ...noteEdit, case_manager_access: 0 })} type="radio" name="case_manager_access" value="0" checked={noteEdit?.case_manager_access == 0 ? true : false} />
                                                <label className="me-0 form-check-label fw-normal"  >NO</label>
                                            </div>




                                        </div>

                                    </div>

                                    <div className="row px-3 py-2 gx-2 align-items-center">

                                        <div className="col-auto">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={!!noteEdit?.pending_payments}
                                                    onChange={(e) =>
                                                        setNoteEdit({
                                                            ...noteEdit,
                                                            pending_payments: e.target.checked ? 1 : 0,
                                                        })
                                                    }
                                                />
                                                <label className="form-check-label">Pending Payment</label>
                                            </div>
                                        </div>

                                        <div className="col-auto">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={!!noteEdit?.paid_payments}
                                                    onChange={(e) =>
                                                        setNoteEdit({
                                                            ...noteEdit,
                                                            paid_payments: e.target.checked ? 1 : 0,
                                                        })
                                                    }
                                                />
                                                <label className="form-check-label">Paid</label>
                                            </div>
                                        </div>


                                    </div>
                                    <div className="row px-3 py-2 gx-2 align-items-center">
                                        {/* UPDATED: Problem case check and width constraint */}
                                        <div className="col-auto">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={noteEdit?.problem_case == 1 || noteEdit?.problem_case === true}
                                                    onChange={(e) =>
                                                        setNoteEdit({
                                                            ...noteEdit,
                                                            problem_case: e.target.checked ? 1 : 0,
                                                            problem_reason: e.target.checked
                                                                ? noteEdit?.problem_reason
                                                                : ""
                                                        })
                                                    }
                                                />
                                                <label className="form-check-label">Problem Case</label>
                                            </div>
                                        </div>

                                        {(noteEdit?.problem_case == 1 || noteEdit?.problem_case === true) && (
                                            <>
                                                <div className="col-auto">
                                                    <label className="mb-0">Reason:</label>
                                                </div>

                                                {/* UPDATED: max-width set to 250px */}
                                                <div className="col-auto" style={{ maxWidth: "220px" }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter reason"
                                                        value={noteEdit?.problem_reason || ""}
                                                        onChange={(e) =>
                                                            setNoteEdit({
                                                                ...noteEdit,
                                                                problem_reason: e.target.value
                                                            })
                                                        }
                                                    />
                                                </div>
                                            </>
                                        )}

                                        {/* ADDED: Fee Approval Checkbox */}
                                        <div className="col-auto">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={noteEdit?.fee_approval == 1 || noteEdit?.fee_approval === true}
                                                    onChange={(e) =>
                                                        setNoteEdit({
                                                            ...noteEdit,
                                                            fee_approval: e.target.checked ? 1 : 0,
                                                            fee_approval_amount: e.target.checked
                                                                ? noteEdit?.fee_approval_amount
                                                                : ""
                                                        })
                                                    }
                                                />
                                                <label className="form-check-label">Fee Approval</label>
                                            </div>
                                        </div>

                                        {/* ADDED: Conditional Fee Input (max-width 100px) */}
                                        {(noteEdit?.fee_approval == 1 || noteEdit?.fee_approval === true) && (
                                            <>
                                                <div className="col-auto">
                                                    <label className="mb-0">Fee:</label>
                                                </div>

                                                <div className="col-auto" style={{ maxWidth: "100px" }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Fee"
                                                        value={noteEdit?.fee_approval_amount || ""}
                                                        onChange={(e) =>
                                                            setNoteEdit({
                                                                ...noteEdit,
                                                                fee_approval_amount: e.target.value
                                                            })
                                                        }
                                                    />
                                                    {inputError &&
                                                        noteEdit?.fee_approval_amount &&
                                                        !/^\d+\.\d{2}$/.test(noteEdit?.fee_approval_amount.toString().trim()) && (
                                                            <span className="text-danger">Enter a valid fee amount (e.g. 100.00)</span>
                                                        )
                                                    }
                                                </div>
                                            </>
                                        )}

                                    </div>
                                    <div className="row px-3 py-2 gx-2 ">
                                        <div className="col-4">
                                            <label htmlFor="note_description">NOTES</label>
                                            <textarea rows="4" name="note_description" id="note_description"
                                                className="form-control"
                                                onChange={(e) =>
                                                    setNoteEdit({ ...noteEdit, note_description: e.target.value })
                                                }

                                            >
                                                {noteEdit?.note_description}
                                            </textarea>


                                        </div>
                                        <div className="col-4">
                                            <label htmlFor="note_internal_description">INTERNAL NOTES</label>
                                            <textarea rows="4" name="note_internal_description" id="note_internal_description" className="form-control"
                                                onChange={(e) => setNoteEdit({ ...noteEdit, note_internal_description: e.target.value })}

                                            >
                                                {noteEdit?.note_internal_description}
                                            </textarea>


                                        </div>



                                        <div className="col-4">
                                            <label htmlFor="correspondence_attachment">CORRESPONDENCE ATTACHMENT</label>

                                            {/* Show existing file download & remove button ONLY if it's a string path (not a File object) */}
                                            {noteEdit?.correspondence_attachment && typeof noteEdit.correspondence_attachment === 'string' && (
                                                <div className="mt-1 mb-2">
                                                    <a
                                                        className="btn btn-sm btn-success me-1"
                                                        href={`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/download-correspondence-attachment/${noteEdit.note_id}`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Download
                                                    </a>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-warning"
                                                        onClick={() =>
                                                            setNoteEdit({
                                                                ...noteEdit,
                                                                correspondence_attachment: null,
                                                                remove_attachment: true
                                                            })
                                                        }
                                                    >
                                                        REMOVE
                                                    </button>
                                                </div>
                                            )}


                                            <div className="input-group w-auto mt-1">
                                                <input
                                                    name="correspondence_attachment"
                                                    id="correspondence_attachment"
                                                    type="file"
                                                    className="form-control"
                                                    onChange={(e) => {
                                                        if (e.target.files[0]) {
                                                            setNoteEdit({
                                                                ...noteEdit,
                                                                correspondence_attachment: e.target.files[0],
                                                                remove_attachment: false
                                                            });
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>

                                    </div>



                                </form>



                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="row">
                        <div className="col text-center">
                            <button className="btn btn-sm btn-success me-1" onClick={() => updateNote()} >UPDATE</button>
                            <button className="btn btn-sm btn-warning" onClick={() => setIsNoteModalOpen(false)} >CLOSE</button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>



        </>

    )

}
export default Notes;